import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'Allgemein',
    [tabs.restaurant_details]: 'Restaurantdetails',
    [tabs.order_conversion]: 'Umwandlung bestellen',
    [tabs.external_delivery]: 'Externe Lieferung',
    [tabs.mobile_app]: 'Mobile app',
    [tabs.customer_success_team]: 'Kundenerfolgsteam',
    [tabs.onboarding_team]: 'Onboarding team',
  },
  date_range: {
    this_month: 'Diesen Monat',
    last_month: 'Letzten Monat',
    last_week: 'Letzte Woche',
    last_year: 'Letztes Jahr',
    this_week: 'Diese Woche',
    this_year: 'Dieses Jahr',
    today: 'Heute',
    yesterday: 'Gestern',
    all: 'Alle',
  },
};
